import React, {useState, useEffect} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import SelectList from '../../components/select/SelectList';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import Toast from '../../components/toast/Toast';
import {validDouble} from '../../utils/const';
import {
  getPotentionalRisks,
  getAllSubProcesses,
  editIncurredRisk,
  getRiskFile,
  getAllSubCauses,
  GetPotentionalRisk,
  getDepartment, deleteCodebook,
} from '../../services/IncurredEvent/incurredEventApi';
import Trash from './img/Trash.svg';
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import Swal from 'sweetalert2';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import allowedFileTypes from '../../utils/allowedFileTypes';
import LossModal from "./components/modals/LossModal";
import editImage from "./components/img/edit.svg";
import deleteImage from "./components/img/delete.svg";

const ShowIncurredRisk = ({defaultData}) => {
  const lang = getLanguage();
  const user = useUserContext();
  const [disabled, setDisabled] = useState();
  const [subProcesses, setSubProcesses] = useState([]);
  const [subCauses, setSubCauses] = useState([]);
  const [potentionalRisks, setPotentionalRisks] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const [files, setFiles] = useState([]);
  const [lossModalOpen,setLossModalOpen] = useState(false);
  const [isEdit,setIsEdit] = useState(false);
  const [lossData, setLossData] = useState(
      defaultData?.riskExpenseDTO.length > 0
          ? defaultData.riskExpenseDTO.map((item) => ({
            ...item,
            lossReason: {
              value: item.lossReason.id,
              label: item.lossReason.name,
            },
          }))
          : []
  );
  const [currentID,setCurrentID] = useState();
  const [yesNoOptions,setYesNoOptions] = useState(  lang === 'eng'
      ? [{value: true, label: 'Yes'},{value:false,label:'No'}]
      : [{value: true, label: 'Da'},{value:false,label:'Ne'}])
  const [defaultFiles, setDefaultFiles] = useState(defaultData?.files);
  const [riskEstimation, setRiskEstimation] = useState(
    defaultData.riskEstimationId
  );

  let history = useHistory();
  const userDepartment = useDepartmentContext();

  const [schema, setSchema] = useState(
    yup.object().shape({
      riskType: yup.object().nullable().required(t('message.fieldRequired')),
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      description: yup
        .string()
        .trim()
        .max(2048, t('message.max2048'))
        .required(t('message.fieldRequired')),
      riskCauseId: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCauseId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      departmentStakeholderId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskCategoryId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      userResponsibleId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      estimatedGrossLost: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .matches(validDouble, t('message.onlyDecimalNumbers'))
        .typeError(t('message.onlyDecimalNumbers')),
      process: yup.object().nullable().required(t('message.fieldRequired')),
      subprocessId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      businessLineId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      creditRiskRelated: yup.object().nullable().required(t('message.fieldRequired')),
      riskMitigationModeName: yup.object().nullable().required(t('message.fieldRequired')),
      typeGainLossId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      methodologyId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup.string().trim().max(2048, t('message.max2048')),
      departmentSourceId: yup
          .object()
          .nullable()
          .required(t('message.fieldRequired')),
    })
  );

  const fetchPotentionalRisks = async () => {
    try {
      const {data} = await getPotentionalRisks();
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };
  const fetchSubprocesses = async () => {
    try {
      const {data} = await getAllSubProcesses(watchProcess['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };
  const fetchSubcauses = async () => {
    try {
      const {data} = await getAllSubCauses(watchRiskCause['value']);
      // setSubProcesses(data);
      return data;
    } catch (e) {}
  };
  useEffect(() => {
    fetchPotentionalRisks().then((r) => {
      let options = [];
      r.forEach((item) => {
        options.push({
          value: item.id,
          label: item.title,
        });
      });
      setPotentionalRisks(options);
    });
    window.location.pathname.includes('edit')
      ? setDisabled(false)
      : setDisabled(true);
  }, []);

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, reset, setValue} = methods;
  const watchRiskType = watch('riskType');
  const watchProcess = watch('process');
  const watchRiskCause = watch('riskCauseId');
  const watchDepartmentSourceId = watch('departmentSourceId');

  useEffect(() => {
    if (watchRiskType?.value !== undefined) {
      if (watchRiskType?.value !== defaultData.potentialRiskId) {
        const fetchPotentialRiskData = async () => {
          try {
            const {data} = await GetPotentionalRisk(watchRiskType?.value);
            setRiskEstimation(data[0].riskEstimationId);
          } catch (e) {
            // console.log(e);
          }
        };
        fetchPotentialRiskData();
      }
    }
  }, [watchRiskType]);

  useEffect(() => {
    if (watchProcess?.value) {
      fetchSubprocesses().then((r) => {
        let subProcesses = [];
        r.forEach((item) => {
          subProcesses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubProcesses(subProcesses);
      });
    }
    if (watchProcess === null) {
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchProcess]);

  useEffect(() => {
    if (watchRiskCause?.value) {
      //setDisableSubCategory(false);
      fetchSubcauses().then((r) => {
        let subCauses = [];
        r.forEach((item) => {
          subCauses.push(
            lang === 'eng'
              ? {value: item.id, label: item.nameEn}
              : {
                  value: item.id,
                  label: item.name,
                }
          );
        });
        setSubCauses(subCauses);
      });
    }
    if (watchRiskCause === null) {
      setValue('riskSubCauseId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCause]);

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;

    const payload = {
      id: defaultData.id,
      riskTypeId: 2,
      potentialRiskId: data.riskType.value,
      title: data.title,
      description: data.description,
      typeGainLossId: data.typeGainLossId.value,
      methodologyId: data.methodologyId.value,
      riskCauseId: data.riskCauseId.value,
      riskSubCauseId: data.riskSubCauseId.value,
      departmentStakeholderId: data.departmentStakeholderId.value,
      riskCategoryId: data.riskCategoryId.value,
      userResponsibleId: data.userResponsibleId.value,
      userResponsibleLogin: defaultData.userResponsibleLogin,
      userCreatedId: defaultData.userCreatedId,
      userCreatedLogin: defaultData.userCreatedLogin,
      userInChargeId: defaultData.userInChargeId,
      userInChargeLogin: defaultData.userInChargeLogin,
      riskStatusId: defaultData.riskStatusId,
      subprocessId: data.subprocessId.value,
      estimatedGrossLost: data.estimatedGrossLost,
      comment: data.comment,
      businessLineId: data.businessLineId.value,
      creditRiskRelated: data.creditRiskRelated?.value,
      riskMitigationModeId: data.riskMitigationModeName?.value,
      riskMitigationModeName: data.riskMitigationModeName?.label,
      applicationDate: new Date(defaultData.applicationDate),
      deleteFiles: deleteFiles,
      riskEstimationId: riskEstimation,
      departmentSourceId: data.departmentSourceId.value,
      riskExpenseDTO: lossData.length > 0 ? lossData.map((item) => (
          {
            id:item.id,
            lossReason: {
              id:item.lossReason.value,
              name: item.lossReason.label
            },
            netLoss: item.netLoss,
            lossDate: item.lossDate
          }
      )) : []
    };

    try {
      const response = await editIncurredRisk(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('message.updateSuccess2', {
            entity: t('common.incurred-risk'),
          }),
          icon: 'success',
        });
      }
      window.location = `/incurred-risk/${parseInt(defaultData.id)}`;
    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Swal.fire({
          text:
            lang === 'eng'
              ? err.response.data.description
              : t('message.addRiskErrorExists'),
          icon: 'error',
        });
      } else {
        Toast.fire({
          title: t('message.errorApi'),
          icon: 'error',
        });
      }
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/incurred-risk/${defaultData.id}`;
  };

  const uploadOnChange = () => {
    const input = document.getElementById('upload');
    let children = [];
    if (input.files.length > 10) {
      Toast.fire({
        title: t('message.tooManyFiles'),
        icon: 'error',
      });
    } else {
      for (let i = 0; i < input.files.length; ++i) {
        if (input.files.item(i).size > 10485760) {
          Toast.fire({
            title: t('message.fileTooBig'),
            icon: 'error',
          });
        } else {
          children.push({
            id: input.files.item(i).name,
            label: input.files.item(i).name,
          });
          setFiles(children);
        }
      }
    }
  };

  const clearFetchedFile = (id) => {
    let children = defaultFiles.filter((file) => file.id !== id);
    let deleteFilesIds = [];
    deleteFilesIds.push(id);
    setDefaultFiles([...children]);
    setDeleteFiles(deleteFilesIds);
  };

  const clearLocalFile = (index) => {
    const dt = new DataTransfer();
    const input = document.getElementById('upload');
    const {files} = input;
    let children = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (index !== i) {
        dt.items.add(file); // here you exclude the file
        children.push({
          id: input.files.item(i).name,
          label: input.files.item(i).name,
        });
      }
    }
    input.files = dt.files;
    setFiles(children);
  };

  const onChangeEstimatedGrossLoss = (e) => {
    let result = '';
    let valueNoText = e.target.value.replace(/[^0-9.]/, '');
    let valueDouble = valueNoText.match(/^(\d+(?:(.|,)\d{1,2})?).*/);
    if (valueDouble !== undefined && valueDouble !== null) {
      result = valueDouble[1];
    }
    setValue('estimatedGrossLost', result);
  };

  const deleteConto = (id) => {
    if(id){
      deleteCodebook(id).then((res) => {
        if(res.status === 204) {
          setLossModalOpen(false);
          setLossData((prevLossData) => prevLossData.filter((item) => item.id !== id));
          Toast.fire({
            title: t('codebook.successfullyDeletedLoss'),
            icon: 'success',
          });
        }
      })
    }else {
      setLossModalOpen(false);
      setLossData((prevLossData) => prevLossData.filter((item) => item.id !== id))
      Toast.fire({
        title: t('codebook.successfullyDeletedLoss'),
        icon: 'success',
      });
    }
  }


  useEffect(() => {
    const index = lossData.findIndex((loss) => loss.id === currentID);
    lossData.forEach((loss, index) => {
      setValue(`lossData.${index}.account`, loss?.lossReason);
    });
    if (index !== -1) {
      const selectedLoss = lossData[index];
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
      setValue(`lossData.${index}.account`, selectedLoss?.lossReason);
    }
  },[lossData])



  // useEffect(() => {
  //   if (watchDepartmentSourceId) {
  //     const depratmentObject = async () => {
  //       try {
  //         const {data} = await getDepartment(watchDepartmentSourceId.value);
  //         setValue('userResponsibleId', {
  //           value: data[0].userResponsibleId,
  //           label:
  //             data[0].userResponsibleFirstName +
  //             ' ' +
  //             data[0].userResponsibleLastName,
  //         });
  //       } catch {}
  //     };
  //     depratmentObject();
  //   }
  // }, [watchDepartmentSourceId]);
  return (
    <>
      {defaultData !== undefined && (
        <>
          <PreventTransitionPrompt when={!disabled} />
          <div className="main-form mt-4">
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(submitForm)}>
                <Row className="field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('incurred-risk.mainData')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.potentionalRisk')}
                    </label>
                    <SelectInfinite
                      api="/risks?riskTypeId.equals=1"
                      name="riskType"
                      placeholder={t(
                        'incurred-risk.placeholder.potentionalRisk'
                      )}
                      labelKey={'title'}
                      className="select"
                      isClearable
                      queryKeys={'title.contains'}
                      defaultValue={
                        defaultData.potentialRiskId !== null
                          ? {
                              value: defaultData.potentialRiskId,
                              label: defaultData.potentialRiskTitle,
                            }
                          : null
                      }
                      isDisabled={disabled}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.title')}
                    </label>
                    <InputText
                      type="text"
                      name="title"
                      className="form-control input-field"
                      placeholder={t('incurred-risk.placeholder.title')}
                      disabled={disabled}
                      defaultValue={defaultData?.title}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.description')}
                    </label>
                    <TextArea
                      name="description"
                      className={`form-control text-area `}
                      placeholder={t('incurred-risk.placeholder.description')}
                      disabled={disabled}
                      defaultValue={defaultData?.description}
                    />
                  </Col>
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('incurred-risk.additionalInformation')}
                  </Col>
                </Row>

                <Row className="mt-2">
                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.category')}
                    </label>
                    <SelectInfinite
                      api="risk-categories"
                      name="riskCategoryId"
                      placeholder={t('incurred-risk.placeholder.category')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={{
                        value: defaultData.riskCategoryId,
                        label:
                          lang === 'mne'
                            ? defaultData.riskCategoryName
                            : defaultData.riskCategoryNameEn,
                      }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.riskCauses')}
                    </label>
                    <SelectInfinite
                      api="risk-causes"
                      name="riskCauseId"
                      placeholder={t('incurred-risk.placeholder.riskCauses')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={{
                        value: defaultData.riskCauseId,
                        label:
                          lang === 'mne'
                            ? defaultData.riskCauseName
                            : defaultData.riskCauseNameEn,
                      }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.subCauses')}
                    </label>
                    <SelectList
                      name="riskSubCauseId"
                      isDisabled={disabled}
                      className="select"
                      placeholder={t('incurred-risk.placeholder.subCauses')}
                      options={subCauses}
                      isClearable
                      defaultValue={{
                        value: defaultData.riskSubCauseId,
                        label:
                          lang === 'mne'
                            ? defaultData.riskSubCauseName
                            : defaultData.riskSubCauseNameEn,
                      }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.typeGainLoss')}
                    </label>
                    <SelectInfinite
                        api="type-gain-losses"
                        name="typeGainLossId"
                        placeholder={t('incurred-risk.placeholder.typeGainLoss')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={disabled}
                        defaultValue={
                          defaultData.typeGainLossId !== null
                              ? {
                                value: defaultData.typeGainLossId,
                                label:
                                    lang === 'mne'
                                        ? defaultData.typeGainLossName
                                        : defaultData.typeGainLossNameEn,
                              }
                              : null
                        }
                    />
                  </Col>

                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.businessLines')}
                    </label>
                    <SelectInfinite
                      api="business-lines"
                      name="businessLineId"
                      placeholder={t('incurred-risk.placeholder.businessLines')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={
                        defaultData.businessLineId !== null
                          ? {
                              value: defaultData.businessLineId,
                              label:
                                lang === 'mne'
                                  ? defaultData.businessLineName
                                  : defaultData.businessLineNameEn,
                            }
                          : null
                      }
                    />
                    <label className="label-incurred">
                      {t('mitigation-measures.method')}
                    </label>
                    <SelectInfinite
                        api="/risk-mitigation-modes"
                        name="riskMitigationModeName"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        placeholder={t('placeholder.riskMitigrationMethod')}
                        isDisabled={disabled}
                        defaultValue={{label: defaultData.riskMitigationModeName,
                          value: defaultData.riskMitigationModeId}}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.process')}
                    </label>
                    <SelectInfinite
                      api="processes"
                      name="process"
                      placeholder={t('incurred-risk.placeholder.process')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={
                        defaultData.processId !== null
                          ? {
                              value: defaultData.processId,
                              label:
                                lang === 'mne'
                                  ? defaultData.processName
                                  : defaultData.processNameEn,
                            }
                          : null
                      }
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.subprocess')}
                    </label>
                    <SelectList
                      name="subprocessId"
                      isDisabled={disabled}
                      placeholder={t('incurred-risk.placeholder.subprocess')}
                      options={subProcesses}
                      isClearable
                      defaultValue={
                        defaultData.subprocessId !== null
                          ? {
                              value: defaultData.subprocessId,
                              label:
                                lang === 'mne'
                                  ? defaultData.subprocessName
                                  : defaultData.subprocessNameEn,
                            }
                          : null
                      }
                    />
                    {!disabled ? (
                        <>
                          <label className="label-incurred">
                            {t('incurred-risk.attachFile')}
                          </label>
                          <span className="optional register">
                          {t('common.optional')}
                        </span>
                          <InputText
                              id="upload"
                              type="file"
                              name="file"
                              className="file-input"
                              multiple
                              onChange={uploadOnChange}
                              disabled={disabled}
                              accept={allowedFileTypes}
                          />
                          <ul className="mb-0" key={defaultFiles}>
                            {defaultFiles?.map((file) => (
                                <li key={file.id}>
                                  <div className="d-flex align-items-center">
                                    <span className="mr-5">{file.fileName}</span>
                                    {disabled ? (
                                        <DownloadOutlined
                                            onClick={() => {
                                              getRiskFile(file.id, file.fileName);
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={Trash}
                                            alt="trash"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              clearFetchedFile(file.id);
                                            }}
                                        />
                                    )}
                                  </div>
                                </li>
                            ))}
                          </ul>
                          <ul /* key={files} */>
                            {files.map((file, index) => (
                                <li key={file.id}>
                                  <div className="d-flex align-items-center">
                                    <span className="mr-5">{file.label}</span>
                                    <img
                                        src={Trash}
                                        alt="trash"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          clearLocalFile(index);
                                        }}
                                    />
                                  </div>
                                </li>
                            ))}
                          </ul>
                        </>
                    ) : (
                        <div>
                          <div>
                            <ul>
                              {defaultFiles?.map((file) => (
                                  <li key={file.id}>
                                    <div className="d-flex align-items-center">
                                      <span className="mr-5">{file.fileName}</span>
                                      <DownloadOutlined
                                          onClick={() => {
                                            getRiskFile(file.id, file.fileName);
                                          }}
                                      />
                                    </div>
                                  </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                    )}
                  </Col>

                  <Col className="col-3 col-xl-3">

                    <label className="label-incurred">
                      {t
                      ('incurred-risk.metodologies')}
                    </label>
                    <SelectInfinite
                      api="methodologies"
                      name="methodologyId"
                      placeholder={t('incurred-risk.placeholder.metodologies')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={{
                        value: defaultData.methodologyId,
                        label:
                          lang === 'mne'
                            ? defaultData.methodologyName
                            : defaultData.methodologyNameEn,
                      }}
                    />

                    {/* prikaz podataka za oj koja je kreirala rizik */}
                        <label className="label-potential-risk">
                          {t('potentialRisk.departmentRisk')}
                        </label>
                    {userDepartment?.length > 1 ? (
                        <SelectInfinite
                          api="departments/departments-user-in-charge"
                          name="departmentSourceId"
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                          isDisabled={disabled}
                        />
                    ) : (
                        <SelectInfinite
                          api="departments/departments-user-in-charge"
                          name="departmentSourceId"
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk'
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="select"
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                          isDisabled={true}
                        />
                    )}

                    <label className="label-incurred">
                      {t('incurred-risk.department')}
                    </label>
                    <SelectInfinite
                      api="departments"
                      name="departmentStakeholderId"
                      placeholder={t('incurred-risk.placeholder.department')}
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={disabled}
                      defaultValue={{
                        value: defaultData.departmentStakeholderId,
                        label:
                          lang === 'mne'
                            ? defaultData.departmentStakeholderName
                            : defaultData.departmentStakeholderNameEn,
                      }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.userInCharge')}
                    </label>
                    <SelectInfinite
                        api="users"
                        name="users"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userInChargeId,
                          label:
                              defaultData.userInChargeFirstName +
                              ' ' +
                              defaultData.userInChargeLastName,
                        }}
                    />
                  </Col>
                  <Col className="col-3 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.isEventConnected')}
                    </label>
                    <SelectList
                        name="creditRiskRelated"
                        className="select"
                        options={yesNoOptions}
                        placeholder={t('incurred-risk.isEventConnectedPlaceholder')}
                        isClearable={false}
                        isDisabled={disabled}
                        defaultValue={
                          defaultData.creditRiskRelated !== null
                              ? {
                                value: defaultData.creditRiskRelated,
                                label:
                                    lang === 'mne'
                                        ? defaultData.creditRiskRelated === true ? 'Da' : 'Ne'
                                        : defaultData.creditRiskRelated === true ? 'Yes' : 'No',
                              }
                              : null
                        }
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.estimatedGrossLoss')}
                    </label>
                    <InputText
                        type="number"
                        name="estimatedGrossLost"
                        className="form-control input-field"
                        placeholder={t(
                            'incurred-risk.placeholder.estimatedGrossLoss'
                        )}
                        disabled={disabled}
                        defaultValue={defaultData.estimatedGrossLost}
                        step=".01"
                        min="0"
                        onChange={onChangeEstimatedGrossLoss}
                    />
                    {/* odgovorno lice */}
                    <label className="label-incurred">
                      {t('incurred-risk.responsibleUser')}
                    </label>
                    <SelectInfinite
                        api="users"
                        name="userResponsibleId"
                        labelKey="firstName"
                        placeholder={t(
                            'incurred-risk.placeholder.responsibleUser'
                        )}
                        className="select"
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userResponsibleId,
                          label:
                              defaultData.userResponsibleFirstName +
                              ' ' +
                              defaultData.userResponsibleLastName,
                        }}
                    />
                    <label className="label-incurred">
                      {t('incurred-risk.additionalComment')}
                    </label>
                    <span className="optional register">
                      {t('common.optional')}
                    </span>
                    <TextArea
                        name="comment"
                        className={`form-control text-area `}
                        placeholder={t(
                            'incurred-risk.placeholder.additionalComment'
                        )}
                        disabled={disabled}
                        defaultValue={defaultData?.comment}
                    />
                  </Col>
                  {/*<Col className="col-6 col-xl-3">*/}

                  {/*</Col>*/}
                </Row>
                <Row>
                <Col className="col-3 col-xl-3">
                <label className="label-incurred">
                  {t('codebook.addIncurredLoss')}
                  {/*{t('incurred-risk.attachFile')}*/}
                </label>
                <span className="optional register">
                       {t('common.optional')}
                    </span>
                <p className={'file-input'} style={{marginBottom: '-8px',
                  backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : '#d3e1f5'
                }} onClick={() => {
                  if(!disabled) {
                    setIsEdit(false)
                    setLossModalOpen(true)
                  }
                }}></p>
                <LossModal
                    open={lossModalOpen}
                    setLossData={setLossData}
                    lossData={lossData}
                    id={currentID}
                    isEdit={isEdit}
                    riskId={defaultData?.id}
                    isOpen={(e) => setLossModalOpen(e)}
                />
                </Col>
                </Row>
                <Row>
                {lossData.map((item,index) => (
                    <>
                      <Col className="col-3 col-xl-3">
                      <label className="label-incurred">
                          {t('codebook.codebook')}
                      </label>
                        <SelectInfinite
                            api="/loss-reasons"
                            name={`lossData.${index}.account`}
                            placeholder={t('incurred-risk.placeholder.category')}
                            labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                            className="select"
                            isDisabled={true}
                            defaultValue={item?.lossReason}
                        />
                      </Col>
                      <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                          {t('codebook.lossDate')}
                        </label>
                        <InputDate
                            name="lossDate"
                            selected={new Date(item?.lossDate)}
                            placeholder={t('codebook.lossDatePlaceholder')}
                            style={{height: '65px!important'}}
                            forceSelected={true}
                            disabled={true}
                            isClearable={false}
                        />
                      </Col>
                      <Col className="col-3 col-xl-3" style={{marginRight: '5px'}}>
                      <label className="label-incurred">
                          {t('codebook.loss')}
                        </label>
                        <InputText
                            type="text"
                            name="netLoss"
                            className="form-control input-field"
                            placeholder={t('incurred-risk.placeholder.title')}
                            disabled={true}
                            value={item?.netLoss}
                        />
                      </Col>
                      {!disabled &&  <><img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => {
                        setLossModalOpen(true)
                        setCurrentID(item.id);
                        setIsEdit(true);
                      }} src={editImage} alt={'edit'}/>
                        <img style={{marginTop: '30px',marginLeft: '5px',cursor: 'pointer'}} onClick={() => deleteConto(item?.id)} src={deleteImage} alt={'delete'}/>
                      </>}
                    </>
                ))}
                </Row>
                <Row className="mt-2">
                  <Col className="col-6 col-xl-3">

                  </Col>
                  <Col className="col-6 col-xl-3">

                  </Col>

                  {/*<Col className="col-6 col-xl-3">*/}
                  {/* */}
                  {/*</Col>*/}
                </Row>
                <Row className="mt-5 field-group-title">
                  <Col className="col-6 col-xl-3">
                    {t('litigation.systemAddedInformation')}
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.id')}
                    </label>
                    <InputText
                      type="text"
                      name="id"
                      className="form-control input-field"
                      disabled={true}
                      defaultValue={defaultData?.id}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.date')}
                    </label>
                    <InputDate
                      name="creationDate"
                      className="form-control input-field"
                      // defaultValue={new Date(defaultData.applicationDate)}
                      selected={new Date(defaultData.applicationDate)}
                      disabled={true}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.status')}
                    </label>
                    <SelectInfinite
                      api="risk-statuses"
                      name="riskStatus"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.riskStatusId,
                        label:
                          lang === 'mne'
                            ? defaultData.riskStatusName
                            : defaultData.riskStatusNameEn,
                      }}
                    />
                  </Col>

                  {/* <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.departmentSource')}
                    </label>
                    <SelectInfinite
                      api="departments"
                      name="departments"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.departmentSourceId,
                        label:
                          lang === 'mne'
                            ? defaultData.departmentSourceName
                            : defaultData.departmentSourceNameEn,
                      }}
                    />
                  </Col> */}
                </Row>
                <Row className="mb-2">

                  {/* <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.userInCharge')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="users"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.userInChargeId,
                        label:
                          defaultData.userInChargeFirstName +
                          ' ' +
                          defaultData.userInChargeLastName,
                      }}
                    />
                  </Col>
                  <Col className="col-6 col-xl-3">
                    <label className="label-incurred">
                      {t('incurred-risk.responsibleUser')}
                    </label>
                    <SelectInfinite
                      api="users"
                      name="users"
                      labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                      className="select"
                      isDisabled={true}
                      defaultValue={{
                        value: defaultData.userResponsibleId,
                        label:
                          defaultData.userResponsibleFirstName +
                          ' ' +
                          defaultData.userResponsibleLastName,
                      }}
                    />
                  </Col> */}
                </Row>
                <Row className="mt-3 form-footer">
                  {!disabled && (
                    <>
                      <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancel}
                      >
                        {t('buttons.cancel')}
                      </button>
                      <button className="primary-btn" type="submit">
                        {t('buttons.save')}
                      </button>
                    </>
                  )}
                </Row>
              </form>
            </FormProvider>
          </div>
        </>
      )}
    </>
  );
};

export default ShowIncurredRisk;
